module.exports = function () {
    $(document).ready(function () {

        var helper = require('./helper');
	    var AjaxController = require('./services/AjaxController');

        /*********************
         * TYPEAHEAD SECTION *
         *********************/
        /** Make engine object */
        var engine = new Bloodhound({
            datumTokenizer: function (datum) {
                return Bloodhound.tokenizers.whitespace(datum.name);
            },
            queryTokenizer: Bloodhound.tokenizers.whitespace,
            remote: {
                url: helper.getOrigin() + "/api/users/all/search/%QUERY",
                wildcard: '%QUERY'
            },
            filter: function (response) {
                return $.map(response, function (object) {
                    return {
                        id: object.userId,
	                    fullName: object.fullName,
                        email: object.email
                    };
                });
            }
        });

        /** Run TypeAhead */
        $('.typeahead').typeahead(null, {
            minLength: 1,
            display: 'fullName',
            valueKey: 'id',
            name: 'suggestions',
            displayKey: 'fullName',
            limit: 15,
            templates: {
                empty: ['<div class="empty-message" style="padding: 10px;"><strong>', 'Unable to find users', '</strong></div>'].join('\n'),
                suggestion: function (data) {
                    return '<p style="font-size: 100%; cursor: pointer;"><strong>' + data.fullName + ' (' + data.email + ')' + '</strong></p>';
                }
            },
            source: engine
        });

        var categoryId = $('input[name="category_id"]').val();
        var permissionId = $('input[name="permission_id"]').val();

        console.log(categoryId);
        console.log(permissionId);

        /*************************************
         * TYPEAHEAD SELECTED PROPERTY EVENT *
         *************************************/
        $('.js-user-add-to-permission').bind('typeahead:select', function (ev, suggestions) {

	        var url = '/api/permissions/user/add';

            var data = {
                user_id: suggestions.userId,
                permission_id: permissionId,
                category_id: categoryId
            };
            var success = function (response) {
	           location.reload();
            }
            var error = function (response) {
                //console.log('Error');
            }

            AjaxController.prototype.send(url, data, success, error);

        });

        $('.js-user-add-to-recipients').bind('typeahead:select', function (ev, suggestions) {

            var url = '/api/email-recipients/user/add';

            var data = {
                user_id: suggestions.userId,
                permission_id: permissionId
            };

            var success = function (response) {
                location.reload();
            }
            var error = function (response) {
                //console.log('Error');
            }

            AjaxController.prototype.send(url, data, success, error);

        });


    });
}();
